if (!customElements.get('custom-modalv2')) {
  class ModalV2 extends HTMLElement {
    constructor() {
      super();
      this.activeIds = [];
      this.activeId = null;
      this.handleKeydown = this.handleKeydown.bind(this); // Bind the method to the class instance
      this.removeModal = this.removeModal.bind(this);
      this.observer = new MutationObserver(() => this.handleContentUpdate());
      this.searchParams = new URLSearchParams(window.location.search);
    }

    handleContentUpdate() {
      const modalId = this.activeIds[this.activeIds.length - 1];
      const elToTrap = this.querySelector(`[data-modal-content="${modalId}"]:not([data-update-focus="false"]):not(template)`); //exclude modals from this with data-update-focus="false"
      if (elToTrap) {
        trapFocus(elToTrap);
      }
    }

    animateIn(modalId = this.activeIds[this.activeIds.length - 1]) {
      const elToAnimate = document.querySelector(`[data-modal-content="${modalId}"]:not(template)`);
      if (!elToAnimate) return;
      trapFocus(elToAnimate);
      elToAnimate.classList.remove('modal-invisible');
      elToAnimate.classList.add('modal-visible');
      ['transitioncancel', 'transitionend'].forEach(eventType => {
        elToAnimate.addEventListener(eventType, () => {
          document.querySelectorAll('[data-modal-id][data-nav-item][data-hover-trigger]').forEach((el) => {
            const elModalId = el.dataset.modalId;
            if (elModalId === this.activeId) return;
            this.close(elModalId);
            if (!this.activeIds.length) document.classList.remove('nav-open', 'overlay');
          });
        });
      });
    }

    animateOut(modalId) {
      const elToAnimate = document.querySelector(`[data-modal-content="${modalId}"]:not(template)`);
      if (!elToAnimate) return;
      elToAnimate.classList.add('modal-invisible');
      elToAnimate.classList.remove('modal-visible');
      ['transitioncancel', 'transitionend'].forEach(eventType => {
        elToAnimate.addEventListener(eventType, () => {
          elToAnimate.remove();
          if (!this.activeIds.length) document.body.classList.remove('nav-open', 'overlay');
        });
      });

      setTimeout(() => {
        if (!this.activeIds.length) document.body.classList.remove('nav-open', 'overlay');
      }, 301);
    }

    open(modalId, parent) {
      if (!modalId) return;
      this.activeId = modalId;
      if (!this.activeIds.some(x => x === modalId)) {
        const template = document.querySelector(`[data-modal-content="${modalId}"]`);
        if (!template) return;
        this.activeIds.push(modalId);
        const newModalElement = document.createElement('div');
        newModalElement.innerHTML = template.cloneNode(true).innerHTML;
        newModalElement.classList.add('modal-invisible');
        newModalElement.setAttribute('role', 'dialog');
        newModalElement.setAttribute('aria-modal', true);

        [...template.attributes].forEach(attr => newModalElement.setAttribute(attr.nodeName, attr.nodeValue));
        if (parent) {
          parent.appendChild(newModalElement);
          document.body.classList.add('nav-open', 'overlay')
        } else this.appendChild(newModalElement);
        document.body.classList.toggle('no-animate-modal', (document.querySelectorAll('[data-modal-content]:not(template)').length > 1));

        setTimeout(() => {
          this.animateIn(modalId);
           /* Start Extole */
           (function(c,e,k,l,a){c[e]=c[e]||{};for(c[e].q=c[e].q||[];a<l.length;)k(l[a++],c[e])})(window,"extole",function(c,e){e[c]=e[c]||function(){e.q.push([c,arguments])}},["createZone"],0);
           /* End Extole */

           window.extole.createZone({
             name: 'global_header',
             element_id: 'extole_zone_global_header'
           });
        }, 1);
        window.addEventListener('keydown', this.handleKeydown);
      }
    }

    closeAll() {
      document.querySelectorAll('[data-modal-content]:not(template)').forEach(el => {
        const activeId = el.dataset.modalContent;
        this.animateOut(activeId);
      });
      this.activeId = null;
      this.activeIds = [];
    }

    close(modalId = this.activeIds[this.activeIds.length - 1]) {
      if (this.activeId == modalId) this.activeId = null;
      if (this.activeIds.find(x => x === modalId)) {
        this.activeIds = this.activeIds.filter(x => x !== modalId);
        document.querySelector(`[data-modal-action="open"][data-modal-id="${modalId}"]:not([data-hover-trigger])`)?.focus();
        this.animateOut(modalId);

        setTimeout(() => {
          document.body.classList.toggle('no-animate-modal', (document.querySelectorAll('[data-modal-content]:not(template)').length > 1));
          document.querySelector(`[data-modal-content="${modalId}"]:not(template)`)?.remove();
          this.classList.remove('hovered');
          if (!this.activeIds.length) {
            document.body.classList.remove('nav-open', 'overlay');
          }
        }, 301);
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }

    removeModal(e) {
      e.target.removeEventListener('mouseleave', this.removeModal);
      document.querySelectorAll('[data-modal-content]:not(template)').forEach(el => {
        const elId = el.dataset.modalContent;
        if (elId === this.activeId) {
          this.close(elId);
        } else {
          this.activeIds = this.activeIds.filter(x => x != elId);
          el.remove();
        }
      });

      setTimeout(() => {
        document.querySelectorAll('[data-modal-content]:not(template).invisible').forEach(el => {
          const elId = el.dataset.modalContent;
          this.activeIds = this.activeIds.filter(x => x != elId);
          if (elId === this.activeId) this.activeId = null;
          el.remove();
        });
        if (!document.querySelector('[data-modal-content]:not(template)')) {
          this.activeId = null;
          this.activeIds = [];
          document.body.classList.remove('nav-open', 'overlay');
          this.classList.remove('hovered');
        }
      }, 301);
    }

    connectedCallback() {
      // this.open(`desktop-menu-AMEtqelczTXBxZUd2N__menu_eGEbWi`, document.querySelector(`[data-modal-action="open"][data-modal-id="desktop-menu-AMEtqelczTXBxZUd2N__menu_eGEbWi"]`));
      this.observer.observe(this, { childList: true, subtree: true });
      if (this.searchParams.get('reset')) {
        if (!window.location.pathname.includes(`account`)) {
          this.open(`account`);
        }
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent(`login:showForm`, { detail: `forgot-pass` }))
        }, 10)
      }

      window.addEventListener('modal:openById', (e) => {
        this.open(e.detail);
      });

      window.addEventListener('modal:closeById', (e) => {
        this.close(e.detail);
      });

      window.addEventListener('mouseover', (e) => {
        const hoveredElement = e.target.closest('[data-modal-action][data-hover-trigger]');
        if (!hoveredElement) return;

        const {
          modalAction,
          modalId
        } = hoveredElement.dataset;

        switch (modalAction) {
          case 'open':
            if (this.activeIds.find(x => x === modalId)) return;
            this.classList.add('hovered');
            this.open(modalId, hoveredElement);
            hoveredElement.addEventListener('mouseleave', this.removeModal);
            break;
          case 'close-all':
            this.closeAll();
            break;
          default: break;
        }
      });

      window.addEventListener('click', (e) => {
        if (e.target.tagName.toLowerCase() === 'custom-modalv2') {
          this.close();
        }

        const clickedElement = e.target.closest('[data-modal-action]');
        if (!clickedElement) return;

        if (clickedElement.closest('[data-hover-trigger]') && document.activeElement !== clickedElement) return;

        const {
          modalAction,
          modalId,
          navItem,
          hoverTrigger
        } = clickedElement.dataset;

        switch (modalAction) {
          case 'open':
            if (modalId === `account` && window.location.pathname.includes(`login`)) { return; }
            window.dispatchEvent(new CustomEvent(`modal-open:${modalId}`));
            if (hoverTrigger) {
              this.open(modalId, clickedElement);
              return;
            }
            if (navItem) {
              document.body.classList.add('nav-open', 'overlay')
            } else document.body.classList.add('overlay');
            this.open(modalId);
            if(modalId == 'search') {
              this.querySelector(`input`).focus();
            }
          break
          case 'close':
            this.close();
            break;
          default: break;
        }
      });
    }
  }

  customElements.define('custom-modalv2', ModalV2);
}